


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxColCountByScreen
} from 'devextreme-vue/form';
import { MeasuringUnitsClient, MeasuringUnitTranslationDto } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxColCountByScreen
  },
})
export default class MeasuringUnitTranslationsDialog extends Vue {
  name: string | undefined | null;

  saving: boolean = false;
  showPopup: boolean = false;
  measuringUnitsClient = new MeasuringUnitsClient(undefined, this.$axios);
  translations: MeasuringUnitTranslationDto[] = [];
  translationsForm: any = {
    measuringUnitTranslations: []
  };
  languages: any[] = [];

  async loadTranslations() {
    if (!this.name) {
      return;
    }

    this.translations = await this.measuringUnitsClient.getTranslations(this.name);
  }

  public async show() {
    this.showPopup = true;

    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];

    await this.loadTranslations();
  }

  public hide() {
    this.name = null;

    this.showPopup = false;
  }

  public async save() {
    if (!this.name) {
      return;
    }

    const translations = this.translationsForm.measuringUnitTranslations.map((t: any) => MeasuringUnitTranslationDto.fromJS({
      language: t.language,
      value: t.value
    }));

    await this.measuringUnitsClient.updateTranslations(this.name, translations);

    this.hide();
  }

  get translationsGroup() {
    const items: any[] = [];

    for (let index = 0; index < this.languages.length; index++) {
      this.translationsForm.measuringUnitTranslations[index] = {
        language: this.languages[index],
        name: '',
        description: ''
      };

      const existingTranslation = this.translations?.find(t => t.language == this.languages[index]);

      if (existingTranslation) {
        this.translationsForm.measuringUnitTranslations[index].value = existingTranslation.value;
      }

      items.push({
        itemType: 'group',
        caption: this.languages[index],
        items: [
          {
            itemType: 'simple',
            dataField: `measuringUnitTranslations[${index}].value`,
            label: {
              text: this.$t('objects.articles.Name')
            }
          }
        ]
      });
    }

    return items;
  }
}
